import { render, staticRenderFns } from "./AppSvg.vue?vue&type=template&id=f849fa04&"
import script from "./AppSvg.vue?vue&type=script&lang=js&"
export * from "./AppSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports